export enum FiPersonalNotificationEnums {
    PersonalTagUsers = 2,
    Personal = 3,
    PersonalToItemsUserComments = 4,
    PersonalToItemsUserLikes = 8,
    PersonalUnpinNewsFeed = 9,
    ChatConversationAddUser = 10,
    ChatConversationRemoveUser = 11,
    Checkpoint2Answered = 12,
}

export enum FiPersonalNotificationProfileType {
    Regular = 0,
    BusinessUnit = 1,
    TaskChecklistAutomated = 2,
    TaskSystemDeadline = 3,
    OnboardingReminder = 4,
}
